/**
 * Application domain enum for utilization calculation mode.
 * Determines whether to calculate utilization against total capacity or billable capacity only.
 */
export enum UtilizationBasedOn {
  TotalCapacity = 'TotalCapacity',
  BillableCapacity = 'BillableCapacity',
}
